{
    "meta": {
        "army_budget": 150,
        "max_army_size": 25,
        "default_ruleset": "classical"
    },
    "archetypes": {
        "swordsmen": {
            "cost": 8,
            "name": "Swordsmen",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "swordsmen_normal.png",
            "strength": 1000.0,
            "morale": 800.0,
            "attack": 12.0,
            "defense": 10.0,
            "armor": 3.0,
            "speed": 2.0,
            "agility": 6.0,
            "charge_bonus": 2.0,
            "bracing_bonus": 2.0,
            "mass": 10.0,
            "vision_range": 350.0,
            "vision_occlusion": 4.0,
            "symbol": "infantry",
            "ranged_attack": 12.0,
            "ranged_defense": 5.0,
            "shield": 4.0,
            "ammo": 1,
            "fire_range": 100.0,
            "fire_rate_ticks": 10,
            "ranged_accuracy": 0.8,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "javelin",
            "attack_speed": 5,
            "weapon": "sword"
        },
        "spearmen": {
            "cost": 8,
            "name": "Spearmen",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "spearmen_normal.png",
            "strength": 1000.0,
            "morale": 900.0,
            "attack": 8.0,
            "defense": 14.0,
            "armor": 4.0,
            "speed": 1.5,
            "agility": 4.0,
            "charge_bonus": 1.0,
            "bracing_bonus": 10.0,
            "mass": 12.0,
            "vision_range": 350.0,
            "vision_occlusion": 6.0,
            "symbol": "infantry",
            "ranged_attack": 0.0,
            "ranged_defense": 6.0,
            "shield": 5.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "weapon": "spear"
        },
        "melee_cavalry": {
            "cost": 12,
            "name": "Melee Cavalry",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "melee_cavalry_normal.png",
            "strength": 800.0,
            "morale": 700.0,
            "attack": 14.0,
            "defense": 8.0,
            "armor": 2.0,
            "speed": 3.5,
            "agility": 10.0,
            "charge_bonus": 8.0,
            "bracing_bonus": 0.0,
            "mass": 15.0,
            "vision_range": 400.0,
            "vision_occlusion": 5.0,
            "symbol": "cavalry",
            "ranged_attack": 0.0,
            "ranged_defense": 3.0,
            "shield": 0.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "weapon": "sword"
        },
        "shock_cavalry": {
            "cost": 14,
            "name": "Shock Cavalry",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "shock_cavalry_normal.png",
            "strength": 900.0,
            "morale": 600.0,
            "attack": 16.0,
            "defense": 6.0,
            "armor": 3.0,
            "speed": 3.0,
            "agility": 6.0,
            "charge_bonus": 14.0,
            "bracing_bonus": 0.0,
            "mass": 20.0,
            "vision_range": 400.0,
            "vision_occlusion": 6.0,
            "symbol": "cavalry",
            "ranged_attack": 0.0,
            "ranged_defense": 4.0,
            "shield": 2.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "weapon": "spear"
        },
        "archers": {
            "cost": 10,
            "name": "Archers",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "archers_normal.png",
            "weapon": "bow",
            "strength": 100.0,
            "morale": 500.0,
            "attack": 4.0,
            "defense": 4.0,
            "armor": 1.0,
            "speed": 1.8,
            "agility": 5.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 0.0,
            "mass": 6.0,
            "attack_speed": 7,
            "vision_range": 450.0,
            "vision_occlusion": 2.0,
            "symbol": "infantry",
            "ranged_attack": 18.0,
            "ranged_defense": 2.0,
            "shield": 0.0,
            "ammo": 35,
            "fire_range": 450.0,
            "fire_rate_ticks": 40,
            "ranged_accuracy": 0.8,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 6,
            "projectile_type": "arrow"
        },
        "horse_archers": {
            "cost": 12,
            "name": "Horse Archers",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "horse_archers_normal.png",
            "strength": 500.0,
            "morale": 500.0,
            "attack": 6.0,
            "defense": 5.0,
            "armor": 1.0,
            "speed": 3.5,
            "agility": 10.0,
            "charge_bonus": 1.0,
            "bracing_bonus": 0.0,
            "mass": 12.0,
            "vision_range": 400.0,
            "vision_occlusion": 2.5,
            "symbol": "cavalry",
            "ranged_attack": 10.0,
            "ranged_defense": 2.0,
            "shield": 0.0,
            "ammo": 22,
            "fire_range": 300.0,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.65,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 5,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "weapon": "bow"
        },
        "skirmishers": {
            "cost": 9,
            "name": "Skirmishers",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "skirmishers_normal.png",
            "strength": 700.0,
            "morale": 600.0,
            "attack": 8.0,
            "defense": 6.0,
            "armor": 2.0,
            "speed": 2.5,
            "agility": 8.0,
            "charge_bonus": 1.0,
            "bracing_bonus": 0.0,
            "mass": 8.0,
            "vision_range": 350.0,
            "vision_occlusion": 1.5,
            "symbol": "infantry",
            "ranged_attack": 20.0,
            "ranged_defense": 3.0,
            "shield": 2.0,
            "ammo": 15,
            "fire_range": 200.0,
            "fire_rate_ticks": 50,
            "ranged_accuracy": 0.8,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 5,
            "projectile_type": "javelin",
            "attack_speed": 5,
            "weapon": "axe"
        },
        "line_infantry": {
            "cost": 9,
            "name": "Line Infantry",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "swordsmen_normal.png",
            "strength": 800.0,
            "morale": 750.0,
            "attack": 5.0,
            "defense": 6.0,
            "armor": 1.0,
            "speed": 1.7,
            "agility": 4.0,
            "charge_bonus": 1.0,
            "bracing_bonus": 4.0,
            "mass": 9.0,
            "vision_range": 350.0,
            "vision_occlusion": 6.0,
            "symbol": "infantry",
            "ranged_attack": 18.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 60,
            "fire_range": 280.0,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.7,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30.0,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "light_infantry": {
            "cost": 9,
            "name": "Light Infantry",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "skirmishers_normal.png",
            "strength": 700.0,
            "morale": 700.0,
            "attack": 6.0,
            "defense": 6.0,
            "armor": 1.0,
            "speed": 2.3,
            "agility": 7.0,
            "charge_bonus": 2.0,
            "bracing_bonus": 2.0,
            "mass": 8.0,
            "vision_range": 380.0,
            "vision_occlusion": 4.0,
            "symbol": "infantry",
            "ranged_attack": 14.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 60,
            "fire_range": 260.0,
            "fire_rate_ticks": 30,
            "ranged_accuracy": 0.72,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "voltigeurs": {
            "cost": 9,
            "name": "Voltigeurs",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "skirmishers_normal.png",
            "strength": 600.0,
            "morale": 600.0,
            "attack": 7.0,
            "defense": 5.0,
            "armor": 1.0,
            "speed": 2.6,
            "agility": 9.0,
            "charge_bonus": 1.0,
            "bracing_bonus": 0.0,
            "mass": 7.0,
            "vision_range": 380.0,
            "vision_occlusion": 2.0,
            "symbol": "infantry",
            "ranged_attack": 14.0,
            "ranged_defense": 3.0,
            "shield": 0.0,
            "ammo": 30,
            "fire_range": 270.0,
            "fire_rate_ticks": 25,
            "ranged_accuracy": 0.72,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60.0,
            "projectile_count": 3,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "riflemen": {
            "cost": 12,
            "name": "Riflemen",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "archers_normal.png",
            "strength": 500.0,
            "morale": 700.0,
            "attack": 6.0,
            "defense": 5.0,
            "armor": 1.0,
            "speed": 2.2,
            "agility": 8.0,
            "charge_bonus": 1.0,
            "bracing_bonus": 0.0,
            "mass": 7.0,
            "vision_range": 450.0,
            "vision_occlusion": 4.0,
            "symbol": "infantry",
            "ranged_attack": 22.0,
            "ranged_defense": 3.0,
            "shield": 0.0,
            "ammo": 28,
            "fire_range": 380.0,
            "fire_rate_ticks": 55,
            "ranged_accuracy": 0.85,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30.0,
            "projectile_count": 3,
            "projectile_type": "rifle_ball",
            "attack_speed": 5
        },
        "grenadiers": {
            "cost": 13,
            "name": "Grenadiers",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "swordsmen_normal.png",
            "strength": 950.0,
            "morale": 900.0,
            "attack": 9.0,
            "defense": 9.0,
            "armor": 2.0,
            "speed": 1.7,
            "agility": 5.0,
            "charge_bonus": 3.0,
            "bracing_bonus": 5.0,
            "mass": 11.0,
            "vision_range": 350.0,
            "vision_occlusion": 6.0,
            "symbol": "infantry",
            "ranged_attack": 18.0,
            "ranged_defense": 5.0,
            "shield": 0.0,
            "ammo": 60,
            "fire_range": 280.0,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.72,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30.0,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "dragoons": {
            "cost": 13,
            "name": "Dragoons",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "sprite": "horse_archers_normal.png",
            "strength": 700.0,
            "morale": 700.0,
            "attack": 12.0,
            "defense": 8.0,
            "armor": 2.0,
            "speed": 3.6,
            "agility": 9.0,
            "charge_bonus": 6.0,
            "bracing_bonus": 0.0,
            "mass": 14.0,
            "vision_range": 400.0,
            "vision_occlusion": 5.0,
            "symbol": "cavalry",
            "ranged_attack": 12.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 22,
            "fire_range": 200.0,
            "fire_rate_ticks": 40,
            "ranged_accuracy": 0.65,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60.0,
            "projectile_count": 4,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "lancers": {
            "cost": 15,
            "name": "Lancers",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "sprite": "shock_cavalry_normal.png",
            "strength": 850.0,
            "morale": 700.0,
            "attack": 14.0,
            "defense": 7.0,
            "armor": 2.0,
            "speed": 3.4,
            "agility": 8.0,
            "charge_bonus": 18.0,
            "bracing_bonus": 0.0,
            "mass": 18.0,
            "vision_range": 400.0,
            "vision_occlusion": 5.0,
            "symbol": "cavalry",
            "ranged_attack": 0.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "foot_artillery": {
            "cost": 18,
            "name": "Foot Artillery",
            "category": "siege",
            "ruleset": "napoleonic",
            "sprite": "catapult_normal.png",
            "strength": 350.0,
            "morale": 500.0,
            "attack": 2.0,
            "defense": 3.0,
            "armor": 4.0,
            "speed": 0.5,
            "agility": 1.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 0.0,
            "mass": 50.0,
            "vision_range": 500.0,
            "vision_occlusion": 3.0,
            "symbol": "siege",
            "ranged_attack": 30.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 25,
            "fire_range": 700.0,
            "fire_rate_ticks": 70,
            "ranged_accuracy": 0.65,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 25.0,
            "projectile_count": 1,
            "projectile_type": "cannonball",
            "attack_speed": 5
        },
        "horse_artillery": {
            "cost": 20,
            "name": "Horse Artillery",
            "category": "siege",
            "ruleset": "napoleonic",
            "sprite": "catapult_normal.png",
            "strength": 300.0,
            "morale": 550.0,
            "attack": 2.0,
            "defense": 3.0,
            "armor": 3.0,
            "speed": 2.2,
            "agility": 4.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 0.0,
            "mass": 35.0,
            "vision_range": 500.0,
            "vision_occlusion": 3.0,
            "symbol": "siege",
            "ranged_attack": 26.0,
            "ranged_defense": 3.0,
            "shield": 0.0,
            "ammo": 22,
            "fire_range": 600.0,
            "fire_rate_ticks": 75,
            "ranged_accuracy": 0.62,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 25.0,
            "projectile_count": 1,
            "projectile_type": "cannonball",
            "attack_speed": 5
        },
        "militia": {
            "cost": 5,
            "name": "Militia",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "swordsmen_normal.png",
            "strength": 600.0,
            "morale": 400.0,
            "attack": 4.0,
            "defense": 4.0,
            "armor": 0.0,
            "speed": 1.6,
            "agility": 4.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 1.0,
            "mass": 8.0,
            "vision_range": 300.0,
            "vision_occlusion": 3.0,
            "symbol": "infantry",
            "ranged_attack": 12.0,
            "ranged_defense": 3.0,
            "shield": 0.0,
            "ammo": 60,
            "fire_range": 220.0,
            "fire_rate_ticks": 50,
            "ranged_accuracy": 0.55,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "guard_infantry": {
            "cost": 16,
            "name": "Guard Infantry",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "swordsmen_normal.png",
            "strength": 1000.0,
            "morale": 1000.0,
            "attack": 11.0,
            "defense": 11.0,
            "armor": 3.0,
            "speed": 1.8,
            "agility": 6.0,
            "charge_bonus": 4.0,
            "bracing_bonus": 6.0,
            "mass": 11.0,
            "vision_range": 380.0,
            "vision_occlusion": 7.0,
            "symbol": "infantry",
            "ranged_attack": 20.0,
            "ranged_defense": 6.0,
            "shield": 0.0,
            "ammo": 60,
            "fire_range": 290.0,
            "fire_rate_ticks": 32,
            "ranged_accuracy": 0.78,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30.0,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "legionaries": {
            "cost": 12,
            "name": "Legionaries",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "swordsmen_normal.png",
            "strength": 1100.0,
            "morale": 900.0,
            "attack": 13.0,
            "defense": 12.0,
            "armor": 5.0,
            "speed": 2.0,
            "agility": 6.0,
            "charge_bonus": 3.0,
            "bracing_bonus": 4.0,
            "mass": 11.0,
            "vision_range": 350.0,
            "vision_occlusion": 5.0,
            "symbol": "infantry",
            "ranged_attack": 14.0,
            "ranged_defense": 6.0,
            "shield": 6.0,
            "ammo": 1,
            "fire_range": 110.0,
            "fire_rate_ticks": 10,
            "ranged_accuracy": 0.85,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "javelin",
            "attack_speed": 5
        },
        "praetorian_guard": {
            "cost": 16,
            "name": "Praetorian Guard",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "swordsmen_normal.png",
            "strength": 1000.0,
            "morale": 1100.0,
            "attack": 16.0,
            "defense": 13.0,
            "armor": 6.0,
            "speed": 2.0,
            "agility": 7.0,
            "charge_bonus": 4.0,
            "bracing_bonus": 5.0,
            "mass": 12.0,
            "vision_range": 380.0,
            "vision_occlusion": 5.0,
            "symbol": "infantry",
            "ranged_attack": 14.0,
            "ranged_defense": 7.0,
            "shield": 7.0,
            "ammo": 1,
            "fire_range": 110.0,
            "fire_rate_ticks": 10,
            "ranged_accuracy": 0.9,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "javelin",
            "attack_speed": 5
        },
        "naked_fanatics": {
            "cost": 7,
            "name": "Naked Fanatics",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "swordsmen_normal.png",
            "strength": 900.0,
            "morale": 1000.0,
            "attack": 16.0,
            "defense": 5.0,
            "armor": 0.0,
            "speed": 2.6,
            "agility": 9.0,
            "charge_bonus": 8.0,
            "bracing_bonus": 0.0,
            "mass": 9.0,
            "vision_range": 350.0,
            "vision_occlusion": 3.0,
            "symbol": "infantry",
            "ranged_attack": 0.0,
            "ranged_defense": 2.0,
            "shield": 0.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "war_chariot": {
            "cost": 14,
            "name": "War Chariot",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "shock_cavalry_normal.png",
            "strength": 700.0,
            "morale": 700.0,
            "attack": 12.0,
            "defense": 6.0,
            "armor": 3.0,
            "speed": 3.4,
            "agility": 7.0,
            "charge_bonus": 12.0,
            "bracing_bonus": 0.0,
            "mass": 22.0,
            "vision_range": 400.0,
            "vision_occlusion": 6.0,
            "symbol": "cavalry",
            "ranged_attack": 10.0,
            "ranged_defense": 3.0,
            "shield": 2.0,
            "ammo": 8,
            "fire_range": 180.0,
            "fire_rate_ticks": 30,
            "ranged_accuracy": 0.6,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60.0,
            "projectile_count": 2,
            "projectile_type": "javelin",
            "attack_speed": 5
        },
        "sacred_band": {
            "cost": 13,
            "name": "Sacred Band",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "spearmen_normal.png",
            "strength": 1000.0,
            "morale": 1100.0,
            "attack": 11.0,
            "defense": 16.0,
            "armor": 5.0,
            "speed": 1.6,
            "agility": 5.0,
            "charge_bonus": 2.0,
            "bracing_bonus": 12.0,
            "mass": 13.0,
            "vision_range": 360.0,
            "vision_occlusion": 6.0,
            "symbol": "infantry",
            "ranged_attack": 0.0,
            "ranged_defense": 7.0,
            "shield": 7.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "war_elephant": {
            "cost": 20,
            "name": "War Elephant",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "shock_cavalry_normal.png",
            "strength": 600.0,
            "morale": 800.0,
            "attack": 18.0,
            "defense": 8.0,
            "armor": 6.0,
            "speed": 2.4,
            "agility": 4.0,
            "charge_bonus": 18.0,
            "bracing_bonus": 0.0,
            "mass": 60.0,
            "vision_range": 400.0,
            "vision_occlusion": 8.0,
            "symbol": "cavalry",
            "ranged_attack": 0.0,
            "ranged_defense": 5.0,
            "shield": 0.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "immortals": {
            "cost": 13,
            "name": "Immortals",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "spearmen_normal.png",
            "strength": 1000.0,
            "morale": 1000.0,
            "attack": 11.0,
            "defense": 13.0,
            "armor": 4.0,
            "speed": 1.9,
            "agility": 6.0,
            "charge_bonus": 2.0,
            "bracing_bonus": 8.0,
            "mass": 11.0,
            "vision_range": 380.0,
            "vision_occlusion": 5.0,
            "symbol": "infantry",
            "ranged_attack": 13.0,
            "ranged_defense": 5.0,
            "shield": 5.0,
            "ammo": 24,
            "fire_range": 380.0,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.78,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 4,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "scythed_chariot": {
            "cost": 14,
            "name": "Scythed Chariot",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "shock_cavalry_normal.png",
            "strength": 500.0,
            "morale": 600.0,
            "attack": 10.0,
            "defense": 5.0,
            "armor": 3.0,
            "speed": 3.6,
            "agility": 5.0,
            "charge_bonus": 22.0,
            "bracing_bonus": 0.0,
            "mass": 25.0,
            "vision_range": 380.0,
            "vision_occlusion": 6.0,
            "symbol": "cavalry",
            "ranged_attack": 0.0,
            "ranged_defense": 3.0,
            "shield": 0.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "heavy_horse_archers": {
            "cost": 14,
            "name": "Heavy Horse Archers",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "horse_archers_normal.png",
            "strength": 600.0,
            "morale": 600.0,
            "attack": 8.0,
            "defense": 7.0,
            "armor": 3.0,
            "speed": 3.4,
            "agility": 9.0,
            "charge_bonus": 2.0,
            "bracing_bonus": 0.0,
            "mass": 14.0,
            "vision_range": 420.0,
            "vision_occlusion": 3.0,
            "symbol": "cavalry",
            "ranged_attack": 13.0,
            "ranged_defense": 3.0,
            "shield": 1.0,
            "ammo": 28,
            "fire_range": 340.0,
            "fire_rate_ticks": 32,
            "ranged_accuracy": 0.72,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 5,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "kontos_lancers": {
            "cost": 15,
            "name": "Kontos Lancers",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "shock_cavalry_normal.png",
            "strength": 700.0,
            "morale": 700.0,
            "attack": 14.0,
            "defense": 8.0,
            "armor": 4.0,
            "speed": 3.2,
            "agility": 7.0,
            "charge_bonus": 16.0,
            "bracing_bonus": 0.0,
            "mass": 20.0,
            "vision_range": 400.0,
            "vision_occlusion": 6.0,
            "symbol": "cavalry",
            "ranged_attack": 0.0,
            "ranged_defense": 4.0,
            "shield": 2.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "cuirassiers": {
            "cost": 16,
            "name": "Cuirassiers",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "sprite": "shock_cavalry_normal.png",
            "strength": 800.0,
            "morale": 850.0,
            "attack": 15.0,
            "defense": 10.0,
            "armor": 5.0,
            "speed": 3.2,
            "agility": 7.0,
            "charge_bonus": 14.0,
            "bracing_bonus": 0.0,
            "mass": 22.0,
            "vision_range": 400.0,
            "vision_occlusion": 6.0,
            "symbol": "cavalry",
            "ranged_attack": 0.0,
            "ranged_defense": 5.0,
            "shield": 0.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "old_guard": {
            "cost": 18,
            "name": "Old Guard",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "swordsmen_normal.png",
            "strength": 1000.0,
            "morale": 1100.0,
            "attack": 12.0,
            "defense": 12.0,
            "armor": 3.0,
            "speed": 1.9,
            "agility": 6.0,
            "charge_bonus": 5.0,
            "bracing_bonus": 7.0,
            "mass": 11.0,
            "vision_range": 380.0,
            "vision_occlusion": 7.0,
            "symbol": "infantry",
            "ranged_attack": 22.0,
            "ranged_defense": 7.0,
            "shield": 0.0,
            "ammo": 60,
            "fire_range": 300.0,
            "fire_rate_ticks": 30,
            "ranged_accuracy": 0.82,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30.0,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "highlanders": {
            "cost": 12,
            "name": "Highlanders",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "swordsmen_normal.png",
            "strength": 900.0,
            "morale": 950.0,
            "attack": 12.0,
            "defense": 8.0,
            "armor": 1.0,
            "speed": 2.0,
            "agility": 7.0,
            "charge_bonus": 6.0,
            "bracing_bonus": 3.0,
            "mass": 10.0,
            "vision_range": 360.0,
            "vision_occlusion": 6.0,
            "symbol": "infantry",
            "ranged_attack": 18.0,
            "ranged_defense": 5.0,
            "shield": 0.0,
            "ammo": 60,
            "fire_range": 280.0,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.74,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30.0,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "rocket_battery": {
            "cost": 16,
            "name": "Rocket Battery",
            "category": "siege",
            "ruleset": "napoleonic",
            "sprite": "catapult_normal.png",
            "strength": 300.0,
            "morale": 500.0,
            "attack": 2.0,
            "defense": 3.0,
            "armor": 2.0,
            "speed": 1.0,
            "agility": 2.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 0.0,
            "mass": 28.0,
            "vision_range": 500.0,
            "vision_occlusion": 3.0,
            "symbol": "siege",
            "ranged_attack": 28.0,
            "ranged_defense": 3.0,
            "shield": 0.0,
            "ammo": 18,
            "fire_range": 800.0,
            "fire_rate_ticks": 60,
            "ranged_accuracy": 0.35,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 25.0,
            "projectile_count": 1,
            "projectile_type": "boulder",
            "attack_speed": 5
        },
        "cossacks": {
            "cost": 11,
            "name": "Cossacks",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "sprite": "horse_archers_normal.png",
            "strength": 600.0,
            "morale": 700.0,
            "attack": 10.0,
            "defense": 7.0,
            "armor": 1.0,
            "speed": 3.8,
            "agility": 10.0,
            "charge_bonus": 6.0,
            "bracing_bonus": 0.0,
            "mass": 12.0,
            "vision_range": 420.0,
            "vision_occlusion": 4.0,
            "symbol": "cavalry",
            "ranged_attack": 10.0,
            "ranged_defense": 3.0,
            "shield": 0.0,
            "ammo": 18,
            "fire_range": 200.0,
            "fire_rate_ticks": 38,
            "ranged_accuracy": 0.6,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60.0,
            "projectile_count": 3,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "pavlov_grenadiers": {
            "cost": 15,
            "name": "Pavlov Grenadiers",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "swordsmen_normal.png",
            "strength": 1000.0,
            "morale": 1000.0,
            "attack": 10.0,
            "defense": 11.0,
            "armor": 3.0,
            "speed": 1.6,
            "agility": 5.0,
            "charge_bonus": 5.0,
            "bracing_bonus": 7.0,
            "mass": 12.0,
            "vision_range": 350.0,
            "vision_occlusion": 7.0,
            "symbol": "infantry",
            "ranged_attack": 19.0,
            "ranged_defense": 6.0,
            "shield": 0.0,
            "ammo": 60,
            "fire_range": 280.0,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.74,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30.0,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "jaegers": {
            "cost": 14,
            "name": "Jaegers",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "archers_normal.png",
            "strength": 550.0,
            "morale": 800.0,
            "attack": 7.0,
            "defense": 6.0,
            "armor": 1.0,
            "speed": 2.4,
            "agility": 9.0,
            "charge_bonus": 1.0,
            "bracing_bonus": 0.0,
            "mass": 7.0,
            "vision_range": 470.0,
            "vision_occlusion": 4.0,
            "symbol": "infantry",
            "ranged_attack": 24.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 30,
            "fire_range": 400.0,
            "fire_rate_ticks": 50,
            "ranged_accuracy": 0.88,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30.0,
            "projectile_count": 3,
            "projectile_type": "rifle_ball",
            "attack_speed": 5
        },
        "uhlans": {
            "cost": 14,
            "name": "Uhlans",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "sprite": "shock_cavalry_normal.png",
            "strength": 800.0,
            "morale": 750.0,
            "attack": 13.0,
            "defense": 7.0,
            "armor": 2.0,
            "speed": 3.5,
            "agility": 8.0,
            "charge_bonus": 16.0,
            "bracing_bonus": 0.0,
            "mass": 17.0,
            "vision_range": 400.0,
            "vision_occlusion": 5.0,
            "symbol": "cavalry",
            "ranged_attack": 0.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "grenzers": {
            "cost": 10,
            "name": "Grenzers",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "skirmishers_normal.png",
            "strength": 650.0,
            "morale": 700.0,
            "attack": 7.0,
            "defense": 6.0,
            "armor": 1.0,
            "speed": 2.4,
            "agility": 8.0,
            "charge_bonus": 1.0,
            "bracing_bonus": 1.0,
            "mass": 7.0,
            "vision_range": 400.0,
            "vision_occlusion": 3.0,
            "symbol": "infantry",
            "ranged_attack": 16.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 40,
            "fire_range": 290.0,
            "fire_rate_ticks": 28,
            "ranged_accuracy": 0.75,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60.0,
            "projectile_count": 4,
            "projectile_type": "musket_ball",
            "attack_speed": 5
        },
        "hussars": {
            "cost": 11,
            "name": "Hussars",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "sprite": "melee_cavalry_normal.png",
            "strength": 600.0,
            "morale": 750.0,
            "attack": 11.0,
            "defense": 7.0,
            "armor": 1.0,
            "speed": 3.7,
            "agility": 10.0,
            "charge_bonus": 8.0,
            "bracing_bonus": 0.0,
            "mass": 13.0,
            "vision_range": 420.0,
            "vision_occlusion": 4.0,
            "symbol": "cavalry",
            "ranged_attack": 0.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 0,
            "fire_range": 0.0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0.0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45.0,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5
        },
        "ww2_rifleman": {
            "cost": 5,
            "squad_size": 4,
            "name": "Rifleman",
            "category": "infantry",
            "ruleset": "ww2",
            "sprite": null,
            "strength": 100.0,
            "morale": 700.0,
            "attack": 1.0,
            "defense": 2.0,
            "armor": 0.0,
            "speed": 2.0,
            "agility": 6.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 1.0,
            "mass": 1.0,
            "vision_range": 400.0,
            "vision_occlusion": 0.5,
            "symbol": "infantry",
            "ranged_attack": 14.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 120,
            "fire_range": 350.0,
            "fire_rate_ticks": 8,
            "ranged_accuracy": 0.75,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60.0,
            "projectile_count": 1,
            "projectile_type": "rifle_ball",
            "attack_speed": 1,
            "penetration": 0.0,
            "suppression_power": 1.0
        },
        "ww2_mg_team": {
            "cost": 9,
            "squad_size": 2,
            "name": "MG Team",
            "category": "infantry",
            "ruleset": "ww2",
            "sprite": null,
            "strength": 120.0,
            "morale": 700.0,
            "attack": 1.0,
            "defense": 2.0,
            "armor": 0.0,
            "speed": 1.3,
            "agility": 3.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 3.0,
            "mass": 2.0,
            "vision_range": 400.0,
            "vision_occlusion": 0.5,
            "symbol": "infantry",
            "ranged_attack": 28.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 200,
            "fire_range": 450.0,
            "fire_rate_ticks": 3,
            "ranged_accuracy": 0.55,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 25.0,
            "projectile_count": 6,
            "projectile_type": "rifle_ball",
            "attack_speed": 1,
            "penetration": 0.0,
            "suppression_power": 2.5
        },
        "ww2_mortar": {
            "cost": 11,
            "squad_size": 3,
            "name": "Mortar Team",
            "category": "infantry",
            "ruleset": "ww2",
            "sprite": null,
            "strength": 90.0,
            "morale": 650.0,
            "attack": 1.0,
            "defense": 1.0,
            "armor": 0.0,
            "speed": 1.2,
            "agility": 3.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 0.0,
            "mass": 2.0,
            "vision_range": 350.0,
            "vision_occlusion": 0.5,
            "symbol": "infantry",
            "ranged_attack": 45.0,
            "ranged_defense": 3.0,
            "shield": 0.0,
            "ammo": 30,
            "fire_range": 700.0,
            "fire_rate_ticks": 40,
            "ranged_accuracy": 0.6,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 180.0,
            "projectile_count": 1,
            "projectile_type": "rifle_ball",
            "attack_speed": 1,
            "penetration": 0.0,
            "indirect_fire": true,
            "splash_radius": 90.0,
            "min_range": 150.0,
            "suppression_power": 4.0
        },
        "ww2_medium_tank": {
            "cost": 20,
            "squad_size": 1,
            "name": "Medium Tank",
            "category": "cavalry",
            "ruleset": "ww2",
            "sprite": null,
            "strength": 600.0,
            "morale": 900.0,
            "attack": 4.0,
            "defense": 8.0,
            "armor": 12.0,
            "speed": 3.0,
            "agility": 4.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 0.0,
            "mass": 40.0,
            "vision_range": 450.0,
            "vision_occlusion": 4.0,
            "symbol": "cavalry",
            "ranged_attack": 60.0,
            "ranged_defense": 18.0,
            "shield": 0.0,
            "ammo": 40,
            "fire_range": 500.0,
            "fire_rate_ticks": 25,
            "ranged_accuracy": 0.8,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 180.0,
            "projectile_count": 1,
            "projectile_type": "rifle_ball",
            "attack_speed": 1,
            "armor_front": 12.0,
            "armor_side": 8.0,
            "armor_rear": 4.0,
            "penetration": 14.0,
            "suppression_power": 3.0,
            "is_vehicle": true
        }
    },
    "custom_units": {
        "rulesets": {
            "classical": {
                "visual_archetype": "swordsmen",
                "base": {
                    "cost": 6,
                    "name": "Population Levy",
                    "category": "infantry",
                    "symbol": "infantry",
                    "strength": 750,
                    "morale": 550,
                    "quality_tier": 1,
                    "shock_resistance": 0.05,
                    "attack": 5,
                    "defense": 5,
                    "armor": 0,
                    "speed": 2,
                    "agility": 5,
                    "charge_bonus": 0,
                    "bracing_bonus": 1,
                    "mass": 8,
                    "vision_range": 350,
                    "vision_occlusion": 3,
                    "ranged_attack": 0,
                    "ranged_defense": 1,
                    "shield": 0,
                    "ammo": 0,
                    "fire_range": 0,
                    "fire_rate_ticks": 0,
                    "ranged_accuracy": 0,
                    "can_fire_while_moving": false,
                    "fire_arc_half_angle": 45,
                    "projectile_count": 1,
                    "projectile_type": "arrow",
                    "troops": 180
                },
                "melee_weapons": {
                    "club": {
                        "name": "Club",
                        "cost": 0
                    },
                    "gladius": {
                        "name": "Gladius",
                        "attack": 3,
                        "defense": -1,
                        "cost": 2
                    },
                    "spear": {
                        "name": "Spear",
                        "attack": 1,
                        "defense": 2,
                        "bracing_bonus": 5,
                        "speed": -0.1,
                        "cost": 2
                    },
                    "two_handed_axe": {
                        "name": "Two-Handed Axe",
                        "attack": 4,
                        "defense": -2,
                        "cost": 2,
                        "two_handed": true,
                        "blocks_shield": true
                    }
                },
                "shields": {
                    "none": {
                        "name": "No Shield",
                        "cost": 0
                    },
                    "small": {
                        "name": "Small Shield",
                        "defense": 1,
                        "ranged_defense": 2,
                        "shield": 2,
                        "speed": -0.05,
                        "cost": 1
                    },
                    "large": {
                        "name": "Large Shield",
                        "defense": 2,
                        "ranged_defense": 4,
                        "shield": 5,
                        "speed": -0.25,
                        "vision_range": -50,
                        "cost": 2
                    }
                },
                "armor": {
                    "none": {
                        "name": "No Armor",
                        "cost": 0
                    },
                    "padded": {
                        "name": "Padded Armor",
                        "armor": 1,
                        "ranged_defense": 1,
                        "speed": -0.05,
                        "cost": 1
                    },
                    "mail": {
                        "name": "Mail Armor",
                        "armor": 3,
                        "ranged_defense": 2,
                        "speed": -0.2,
                        "agility": -1,
                        "cost": 3
                    },
                    "heavy": {
                        "name": "Heavy Armor",
                        "armor": 5,
                        "ranged_defense": 3,
                        "speed": -0.4,
                        "agility": -2,
                        "cost": 5
                    }
                },
                "ranged_weapons": {
                    "none": {
                        "name": "No Ranged Weapon",
                        "cost": 0
                    },
                    "javelins": {
                        "name": "Javelins",
                        "ranged_attack": 8,
                        "ammo": 10,
                        "fire_range": 180,
                        "fire_rate_ticks": 45,
                        "ranged_accuracy": 0.7,
                        "projectile_count": 4,
                        "projectile_type": "javelin",
                        "cost": 2
                    },
                    "bow": {
                        "name": "Bow",
                        "ranged_attack": 12,
                        "ammo": 30,
                        "fire_range": 420,
                        "fire_rate_ticks": 45,
                        "ranged_accuracy": 0.72,
                        "projectile_count": 5,
                        "projectile_type": "arrow",
                        "cost": 4,
                        "blocks_shield": true
                    }
                },
                "mounts": {
                    "none": {
                        "name": "No Mount",
                        "cost": 0
                    },
                    "horse": {
                        "name": "Horse",
                        "category": "cavalry",
                        "symbol": "cavalry",
                        "speed": 1.2,
                        "agility": 3,
                        "charge_bonus": 4,
                        "mass": 5,
                        "strength": -100,
                        "vision_range": 50,
                        "troops": 80,
                        "cost": 4
                    }
                },
                "training_tracks": {
                    "weapon": {
                        "name": "Weapon Drill",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "melee_weapon"
                        ],
                        "rank_10": {
                            "attack": 5
                        }
                    },
                    "shield": {
                        "name": "Shield Drill",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "shield"
                        ],
                        "rank_10": {
                            "ranged_defense": 5,
                            "shield": 3
                        }
                    },
                    "formation": {
                        "name": "Formation Discipline",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "always"
                        ],
                        "rank_10": {
                            "defense": 3,
                            "bracing_bonus": 2,
                            "morale": 60
                        }
                    },
                    "endurance": {
                        "name": "Endurance",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "always"
                        ],
                        "rank_10": {
                            "fatigue_buildup_multiplier": 0.7,
                            "fatigue_recovery_multiplier": 1.3
                        }
                    },
                    "skirmishing": {
                        "name": "Skirmishing",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "ranged_weapon"
                        ],
                        "rank_10": {
                            "ranged_accuracy": 0.15
                        }
                    },
                    "horsemanship": {
                        "name": "Horsemanship",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "mount"
                        ],
                        "rank_10": {
                            "speed": 0.25,
                            "agility": 2,
                            "charge_bonus": 3
                        }
                    },
                    "fieldcraft": {
                        "name": "Fieldcraft",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "always"
                        ],
                        "rank_10": {
                            "vision_range": 100,
                            "speed": 0.15
                        }
                    }
                },
                "culture_modifiers": {
                    "roman": {
                        "name": "Roman Drill",
                        "default": {
                            "attack": 1
                        }
                    },
                    "gaul": {
                        "name": "Gallic Defiance",
                        "default": {
                            "defense": 1,
                            "morale": 50,
                            "shock_resistance": 0.02
                        }
                    },
                    "carthaginian": {
                        "name": "Punic Spear Schools",
                        "default": {
                            "bracing_bonus": 1
                        },
                        "spear": {
                            "defense": 1,
                            "bracing_bonus": 3
                        }
                    },
                    "persian": {
                        "name": "Persian Horsemanship",
                        "default": {
                            "agility": 1
                        },
                        "mounted": {
                            "speed": 0.15,
                            "charge_bonus": 2
                        }
                    },
                    "steppe": {
                        "name": "Steppe Riding",
                        "default": {
                            "agility": 1
                        },
                        "mounted_ranged": {
                            "speed": 0.15,
                            "ranged_accuracy": 0.08,
                            "can_fire_while_moving": true
                        }
                    }
                }
            }
        }
    },
    "cultures": {
        "classical": {
            "carthaginian": {
                "display_name": "Helenic",
                "default_color": "#8e44ad",
                "banner": "tanit",
                "banned_units": [
                    "archers",
                    "heavy_horse_archers",
                    "immortals",
                    "kontos_lancers",
                    "legionaries",
                    "naked_fanatics",
                    "praetorian_guard",
                    "scythed_chariot",
                    "war_chariot"
                ],
                "unit_caps": {
                    "horse_archers": 1
                }
            },
            "gaul": {
                "display_name": "Barbarian",
                "default_color": "#3a7d44",
                "banner": "boar",
                "banned_units": [
                    "archers",
                    "catapult",
                    "heavy_horse_archers",
                    "immortals",
                    "kontos_lancers",
                    "legionaries",
                    "praetorian_guard",
                    "sacred_band",
                    "scythed_chariot",
                    "shock_cavalry",
                    "skirmishers",
                    "war_elephant"
                ],
                "unit_caps": {
                    "war_chariot": 2
                }
            },
            "persian": {
                "display_name": "Eastern",
                "default_color": "#e6b800",
                "banner": "winged_sun",
                "banned_units": [
                    "heavy_horse_archers",
                    "kontos_lancers",
                    "legionaries",
                    "naked_fanatics",
                    "praetorian_guard",
                    "sacred_band",
                    "war_chariot",
                    "war_elephant"
                ],
                "unit_caps": {
                    "archers": 2,
                    "spearmen": 2,
                    "swordsmen": 2
                }
            },
            "roman": {
                "display_name": "Heavy Infantry",
                "default_color": "#b22222",
                "banner": "eagle",
                "banned_units": [
                    "heavy_horse_archers",
                    "horse_archers",
                    "immortals",
                    "kontos_lancers",
                    "naked_fanatics",
                    "sacred_band",
                    "scythed_chariot",
                    "war_chariot",
                    "war_elephant"
                ],
                "unit_caps": {
                    "melee_cavalry": 2
                }
            },
            "steppe": {
                "display_name": "Nomadic",
                "default_color": "#5d4037",
                "banner": "horsetail",
                "banned_units": [
                    "battering_ram",
                    "catapult",
                    "immortals",
                    "legionaries",
                    "naked_fanatics",
                    "praetorian_guard",
                    "sacred_band",
                    "scythed_chariot",
                    "swordsmen",
                    "war_chariot",
                    "war_elephant"
                ],
                "unit_caps": {
                    "skirmishers": 2,
                    "spearmen": 2
                }
            }
        },
        "napoleonic": {
            "austrian": {
                "display_name": "Austrian Empire",
                "default_color": "#fdd835",
                "banner": "habsburg_eagle",
                "banned_units": [],
                "unit_caps": {
                    "dragoons": 2,
                    "riflemen": 1
                }
            },
            "british": {
                "display_name": "British Empire",
                "default_color": "#c0392b",
                "banner": "union_jack",
                "banned_units": [
                    "lancers"
                ],
                "unit_caps": {}
            },
            "french": {
                "display_name": "French Empire",
                "default_color": "#1565c0",
                "banner": "tricolor",
                "banned_units": [
                    "militia"
                ],
                "unit_caps": {}
            },
            "prussian": {
                "display_name": "Kingdom of Prussia",
                "default_color": "#37474f",
                "banner": "iron_cross",
                "banned_units": [],
                "unit_caps": {
                    "militia": 2
                }
            },
            "russian": {
                "display_name": "Russian Empire",
                "default_color": "#2e7d32",
                "banner": "double_eagle",
                "banned_units": [],
                "unit_caps": {
                    "riflemen": 1
                }
            }
        },
        "ww2": {
            "us_army": {
                "display_name": "United States Army",
                "default_color": "#2e7d32",
                "banner": "stars_and_stripes",
                "banned_units": [],
                "unit_caps": {}
            },
            "wehrmacht": {
                "display_name": "Wehrmacht",
                "default_color": "#37474f",
                "banner": "balkenkreuz",
                "banned_units": [],
                "unit_caps": {}
            }
        }
    }
}
